import i18n from "@/i18ns/i18n";
import commonFunction from "@/commons/commonFunction";
import store from "@/stores/store";

/**
 * Xử lý hiển thị popup
 */
class PopupUtil {
    /**
     * Đối tượng cache lại các component popup
     */
    _components = {};

    /**
     * Danh sách các popup đang hiển thị
     * key: tên popup
     * value: instance
     */
    _visible = {};

    /**
     * Ẩn tất cả các popup đang hiển thị đi
     */
    hideAll() {
        const me = this;
        let names = [];
        for (let i in me._visible) {
            names.push(i);
        }
        names.forEach(item => {
            me.hide(item);
        });
    }

    /**
     * Ẩn popup theo tên nếu đang hiển thị
     */
    hide(name) {
        let popup = this._visible[name];
        if (popup) {
            delete this._visible[name];
            if (typeof popup.beforeHide === "function") {
                popup.beforeHide();
            }
            // if (typeof popup.close === "function") {
            //     popup.close();
            // }
        }
    }

    /**
     * Hiển popup chi tiết
     * @param {Object} owner Form/Component gọi show
     * @param {EnumQuickAdd} type Loại popup
     * @param {} data Các trường thông tin mặc định cho đối tượng được mở form lên
     * @param {Object} options Các biến hỗ trợ điều khiền luồng
     * @public
     */
    show(owner, type, data, options) {
        var me = this,
            component = me._components[type];
        // console.log('showPopup', type, data, options);

        if (!type) {
            throw new Error("DEV: Vui lòng xem lại cấu hình popup.");
        } else {
            var promise;
            options = options || {};
            me._customParam(type, options);
            if (!component) {
                component = me._loadComponent(type);

                if (component) {
                    promise = new Promise((resolve, reject) => {
                        var fnSuccess = function (module) {
                            if (module) {
                                var popupModule = module.default;
                                if (process.env.NODE_ENV === 'development') {
                                    console.log(popupModule.__file);
                                }
                                if (popupModule) {
                                    me._components[type] = popupModule;
                                    me._show(type, popupModule, owner, options, data).then(
                                        record => {
                                            resolve(record);
                                        },
                                        function (error) {
                                            reject(error);
                                        }
                                    );
                                }
                            }
                        };

                        var fnFailure = function (error) {
                            commonFunction.handleException(error);
                            reject(error);
                        };

                        component.then(fnSuccess, fnFailure);
                    });
                }
            } else {
                promise = me._show(type, component, owner, options, data);
            }

            return promise;
        }
    }

    /**
     * Lấy ra options để truyền sang form dialog quickAdd cho một số tình huống đặc thù
     */
    _customParam(type, options) { }

    /**
     * Show form popup
     */
    _show(type, component, owner, options, data) {
        const me = this;
        var promise = new Promise((resolve, reject) => {
            if (component) {
                let frm;
                // pvduy thêm đoạn này để xử lý có thể truyền data vào một popup đang show (Đã trao đổi với SA a BNĐức)
                if (options.single && me._visible[type]) {
                    frm = me._visible[type];
                    options._reshow = true;
                    frm.show(data, options);
                    return;
                }

                frm = commonFunction.renderDynamicElement(
                    document.body,
                    component,
                    owner, {
                    i18n,
                    store,
                }, true
                );
                if (frm) {
                    //tracking để quản lý các popup đang hiển thị
                    me._visible[type] = frm;
                    if (owner) {
                        frm.$$router = owner.$router;
                        frm.$$route = owner.$route;
                    }

                    //khi đóng form chi tiết -> lắng nghe để giải phóng
                    frm.$on("close", function () {
                        //để timeout để đảm bảm event chạy xong hết rồi mới giải phóng form
                        setTimeout(() => {
                            document.body.removeChild(frm.$el);
                            delete frm.ownerForm;
                            delete frm.editMode;
                            delete frm.active;
                            delete frm.$$router;
                            delete frm.$$route;

                            frm.$destroy();
                            delete me._visible[type];
                        }, 10);

                        //gọi hàm close nếu có
                        if (options && typeof options.close === "function") {
                            options.close();
                        }
                    });

                    if (options) {
                        //sự kiện dùng cho base quickSearch
                        if (typeof options.searchSubmit === "function") {
                            frm.$on("searchsubmit", options.searchSubmit);
                        }

                        if (typeof options.submit === "function") {
                            frm.$on("submit", options.submit);
                        }
                    }

                    frm.ownerForm = owner;
                    if (options.mode) {
                        frm.editMode = options.mode;
                    }

                    if (typeof (frm.active) === 'boolean') {
                        frm.active = true;
                    }
                    if (typeof frm.show === "function") {
                        frm.show(data, options);
                    }
                }
            }
        });

        return promise;
    }

    /**
     * render element vào target element
     * @param {HTMLElement} target vùng target để render
     * @param {Object} owner Form/Component gọi show
     * @param {EnumQuickAdd} type Loại popup
     * @param {} data Các trường thông tin mặc định cho đối tượng được mở form lên
     * @param {Object} options Các biến hỗ trợ điều khiền luồng
     * @public
     */
    append(target, owner, type, data, options, isAppendTarget) {
        var me = this,
            component = me._components[type];

        if (!type) {
            throw new Error("DEV: Vui lòng xem lại cấu hình popup.");
        } else {
            var promise;
            options = options ? options : {};
            me._customParam(type, options);

            if (!component) {
                component = me._loadComponent(type);

                if (component) {
                    promise = new Promise((resolve, reject) => {
                        var fnSuccess = function (module) {
                            if (module) {
                                var popupModule = module.default;
                                if (popupModule) {
                                    me._components[type] = popupModule;
                                    me._append(target, popupModule, owner, options, data, isAppendTarget).then(
                                        record => {
                                            resolve(record);
                                        },
                                        function (error) {
                                            reject(error);
                                        }
                                    );
                                }
                            }
                        };

                        var fnFailure = function (error) {
                            commonFunction.handleException(error);
                            reject(error);
                        };

                        component.then(fnSuccess, fnFailure);
                    });
                }
            } else {
                promise = me._append(target, component, owner, options, data, isAppendTarget);
            }

            return promise;
        }
    }

    /**
     * render show
     */
    _append(target, component, owner, options, data, isAppendTarget) {
        var promise = new Promise((resolve, reject) => {
            if (owner && component) {
                let frm = commonFunction.renderDynamicElement(
                    target,
                    component,
                    owner, {
                    i18n,
                    store
                },
                    isAppendTarget
                );
                if (frm) {
                    //khi đóng form chi tiết -> lắng nghe để giải phóng
                    frm.$on("close", function () {
                        if (typeof options.close === "function") {
                            options.close();
                        } else {
                            commonFunction.focusFirstControlInput(owner.$el)
                        }

                        target.removeChild(frm.$el);
                        frm.$destroy();
                    });

                    //submit
                    if (typeof options.submit === "function") {
                        frm.$on("submit", options.submit);
                    }

                    frm.ownerForm = owner;
                    if (options.mode) {
                        frm.editMode = options.mode;
                    }

                    if (typeof (frm.active) === 'boolean') {
                        frm.active = true;
                    }
                    if (typeof frm.show === "function") {
                        frm.show(data, options);
                    }
                }
            }
        });

        return promise;
    }

    /**
     * Thực hiện load các component quickAdd theo type
     * @privates
     */
    _loadComponent(type) {
        var component;
        switch (type) {
            case "DeviceWideProfileDetail":
                component =
                    import(
                        /*webpackChunkName:'DeviceWideProfileDetail'*/
                        "@/views/device/DeviceWideProfileDetail.vue"
                    );
                break;
            case "DeviceDeepProfileDetail":
                component =
                    import(
                        /*webpackChunkName:'DeviceDeepProfileDetail'*/
                        "@/views/device/DeviceDeepProfileDetail.vue"
                    );
                break;
            case "DeviceDetail":
                component =
                    import(
                        /*webpackChunkName:'DeviceDetail'*/
                        "@/views/device/DeviceDetail.vue"
                    );
                break;
            case "ScanEngineDetail":
                component =
                    import(
                        /*webpackChunkName:'ScanEngineDetail'*/
                        "@/views/scanengine/ScanEngineDetail.vue"
                    );
                break;
            case "WebsiteDeepProfileDetail":
                component =
                    import(
                        /*webpackChunkName:'WebsiteDeepProfileDetail'*/
                        "@/views/website/WebsiteDeepProfileDetail.vue"
                    );
                break;
            case "UserDetail":
                component =
                    import(
                        /*webpackChunkName:'UserDetail'*/
                        "@/views/user/UserDetail.vue"
                    );
                break;
            case "UpdateDataHot":
                component =
                    import(
                        /*webpackChunkName:'UpdateDataHot'*/
                        "@/views/search/UpdateDataHot.vue"
                    );
                break;
            case "RoleDetail":
                component =
                    import(
                        /*webpackChunkName:'RoleDetail'*/
                        "@/views/role/RoleDetail.vue"
                    );
                break;
            case "WebsiteWideProfileDetail":
                component =
                    import(
                        /*webpackChunkName:'WebsiteWideProfileDetail'*/
                        "@/views/website/WebsiteWideProfileDetail.vue"
                    );
                break;
            case "ProxyDetail":
                component =
                    import(
                        /*webpackChunkName:'ProxyDetail'*/
                        "@/views/anonymous/ProxyDetail.vue"
                    );
                break;
            case "ChangePassword":
                component =
                    import(
                        /*webpackChunkName:'ChangePassword'*/
                        "@/views/user/ChangePassword.vue"
                    );
                break;
            case "FormChooseSyntax":
                component =
                    import(
                        /*webpackChunkName:'FormChooseSyntax'*/
                        "@/views/user/FormChooseSyntax.vue"
                    );
                break;
            case "AIReportPopup":
                component =
                    import(
                        /*webpackChunkName:'AIReportPopup'*/
                        "@/views/control/AIReportPopup.vue"
                    );
                break;
            case "DeviceWideProfileResultPort":
                component =
                    import(
                        /*webpackChunkName:'DeviceWideProfileResultPort'*/
                        "@/views/device/DeviceWideProfileResultPort.vue"
                    );
                break;
            case "DeviceWideProfileResultDevice":
                component =
                    import(
                        /*webpackChunkName:'DeviceWideProfileResultDevice'*/
                        "@/views/device/DeviceWideProfileResultDevice.vue"
                    );
                break;
            case "DeviceWideProfileResultIssues":
                component =
                    import(
                        /*webpackChunkName:'DeviceWideProfileResultIssues'*/
                        "@/views/device/DeviceWideProfileResultIssues.vue"
                    );
                break;
            case "WebsiteWideProfileResultPort":
                component =
                    import(
                        /*webpackChunkName:'WebsiteWideProfileResultPort'*/
                        "@/views/website/WebsiteWideProfileResultPort.vue"
                    );
                break;
            case "WebsiteWideProfileResultDevice":
                component =
                    import(
                        /*webpackChunkName:'WebsiteWideProfileResultDevice'*/
                        "@/views/website/WebsiteWideProfileResultDevice.vue"
                    );
                break;
            case "WebsiteWideProfileResultIssues":
                component =
                    import(
                        /*webpackChunkName:'WebsiteWideProfileResultIssues'*/
                        "@/views/website/WebsiteWideProfileResultIssues.vue"
                    );
                break;
            case "NetworkLocationSearch":
                component =
                    import(
                        /*webpackChunkName:'NetworkLocationSearch'*/
                        "@/views/control/NetworkLocationSearch.vue"
                    );
                break;
            case "PortsPopup":
                component =
                    import(
                        /*webpackChunkName:'PortsPopup'*/
                        "@/views/control/PortsPopup.vue"
                    );
                break;
            case "TargetsPopup":
                component =
                    import(
                        /*webpackChunkName:'TargetsPopup'*/
                        "@/views/control/TargetsPopup.vue"
                    );
                break;
            case "SubdomainsPopup":
                component =
                    import(
                        /*webpackChunkName:'SubdomainsPopup'*/
                        "@/views/control/SubdomainsPopup.vue"
                    );
                break;
            case "DeviceDeepProfileResultIssues":
                component =
                    import(
                        /*webpackChunkName:'DeviceDeepProfileResultIssues'*/
                        "@/views/device/DeviceDeepProfileResultIssues.vue"
                    );
                break;
            case "WebsiteDeepProfileResultIssues":
                component =
                    import(
                        /*webpackChunkName:'WebsiteDeepProfileResultIssues'*/
                        "@/views/website/WebsiteDeepProfileResultIssues.vue"
                    );
                break;
            case "DeepProfileDetail":
                component =
                    import(
                        /*webpackChunkName:'DeepProfileDetail'*/
                        "@/views/deep/DeepProfileDetail.vue"
                    );
                break;
            case "WideProfileDetail":
                component =
                    import(
                        /*webpackChunkName:'WideProfileDetail'*/
                        "@/views/wide/WideProfileDetail.vue"
                    );
                break;
            case "RedditDetail":
                component =
                    import(
                        /*webpackChunkName:'RedditDetail'*/
                        "@/views/datalake/RedditDetail.vue"
                    );
                break;
            case "RssSourcesDetail":
                component =
                    import(
                        /*webpackChunkName:'RssSourcesDetail'*/
                        "@/views/datalake/RssSourcesDetail.vue"
                    );
                break;
            case "ChannelDetail":
                component =
                    import(
                        /*webpackChunkName:'ChannelDetail'*/
                        "@/views/datalake/ChannelDetail.vue"
                    );
                break;
            case "MonitorDetail":
                component =
                    import(
                        /*webpackChunkName:'MonitorDetail'*/
                        "@/views/cvepoc/MonitorDetail.vue"
                    );
                break;
            case "SearchCve":
                component =
                    import(
                        /*webpackChunkName:'SearchCve'*/
                        "@/views/ai/SearchCve.vue"
                    );
                break;
            case "ExploitDetail":
                component =
                    import(
                        /*webpackChunkName:'ExploitDetail'*/
                        "@/views/exploit/ExploitDetail.vue"
                    );
                break;
            case "DetailCve":
                component =
                    import(
                        /*webpackChunkName:'DetailCvePopup'*/
                        "@/views/control/DetailCvePopup.vue"
                    );
                break;
             case "DetailMonitor":
                component =
                    import(
                        /*webpackChunkName:'DetailMonitorPopup'*/
                        "@/views/control/DetailMonitorPopup.vue"
                    );
                break;
            case "DetailEdb":
                component =
                    import(
                        /*webpackChunkName:'DetailEdbPopup'*/
                        "@/views/control/DetailEdbPopup.vue"
                    );
                break; 
            case "DetailReddit":
                component =
                    import(
                        /*webpackChunkName:'DetailRedditPopup'*/
                        "@/views/control/DetailRedditPopup.vue"
                    );
                break; 
            case "DetailChannel":
                component =
                    import(
                        /*webpackChunkName:'DetailChannelPopup'*/
                        "@/views/control/DetailChannelPopup.vue"
                    );
                break; 
            case "DetailMessage":
                component =
                    import(
                        /*webpackChunkName:'DetailMessagePopup'*/
                        "@/views/control/DetailMessagePopup.vue"
                    );
                break;
            case "DetailEvent":
                component =
                    import(
                        /*webpackChunkName:'DetailEventPopup'*/
                        "@/views/control/DetailEventPopup.vue"
                    );
                break; 
            case "CredentialDetail":
                component =
                    import(
                        /*webpackChunkName:'CredentialDetailPopup'*/
                        "@/views/control/CredentialDetailPopup.vue"
                    );
                break; 
            case "DetailRssSource":
                component =
                    import(
                        /*webpackChunkName:'DetailRssSourcePopup'*/
                        "@/views/control/DetailRssSourcePopup.vue"
                    );
                break; 
            case "AttackProfileDetail":
                component =
                    import(
                        /*webpackChunkName:'AttackProfileDetail'*/
                        "@/views/attack/AttackProfileDetail.vue"
                    );
                break;
            case "AttackResultPopup":
                component =
                    import(
                        /*webpackChunkName:'AttackResultPopup'*/
                        "@/views/attack/AttackResultPopup.vue"
                    );
                break;
            case "PocDetail":
                component =
                    import(
                        /*webpackChunkName:'PocDetail'*/
                        "@/views/attack/PocDetail.vue"
                    );
                break;
            case "CreateWorkspaceDetail":
                component =
                    import(
                        /*webpackChunkName:'CreateWorkspaceDetail'*/
                        "@/views/attack/CreateWorkspaceDetail.vue"
                    );
                break;
            case "PocResultPopup":
                component =
                    import(
                        /*webpackChunkName:'PocResultPopup'*/
                        "@/views/attack/PocResultPopup.vue"
                    );
                break;
            case "NzTemplateDetail":
                component =
                    import(
                        /*webpackChunkName:'NzTemplateDetail'*/
                        "@/views/template/NzTemplateDetail.vue"
                    );
                break;
            case "NzTemplateSearch":
                component =
                    import(
                        /*webpackChunkName:'NzTemplateSearch'*/
                        "@/views/template/NzTemplateSearch.vue"
                    );
                break;
            case "LeakAccountReportParam":
                component =
                    import(
                        /*webpackChunkName:'LeakAccountReportParam'*/
                        "@/views/leak/LeakAccountReportParam.vue"
                    );
                break;
            case "LeakAccountDetail":
                component =
                    import(
                        /*webpackChunkName:'LeakAccountDetail'*/
                        "@/views/leak/LeakAccountDetail.vue"
                    );
                break;
            case "CvePocDetail":
                component =
                    import(
                        /*webpackChunkName:'CvePocDetail'*/
                        "@/views/cvepoc/CvePocDetail.vue"
                    );
                break;
            case "CvePocTaskDetail":
                component =
                    import(
                        /*webpackChunkName:'CvePocTaskDetail'*/
                        "@/views/cvepoc/CvePocTaskDetail.vue"
                    );
                break;
            case "CvePocTaskDetailResult":
                component =
                    import(
                        /*webpackChunkName:'CvePocTaskDetailResult'*/
                        "@/views/cvepoc/CvePocTaskDetailResult.vue"
                    );
                break;
            case "CvePocTaskListPopup":
                component =
                    import(
                        /*webpackChunkName:'CvePocTaskListPopup'*/
                        "@/views/cvepoc/CvePocTaskListPopup.vue"
                    );
                break;
            case "AddHostsDetail":
                component =
                    import(
                        /*webpackChunkName:'AddHostsDetail'*/
                        "@/views/attack/AddHostsDetail.vue"
                    );
                break;
            case "ViewHostsDetail":
                component =
                    import(
                        /*webpackChunkName:'ViewHostsDetail'*/
                        "@/views/attack/ViewHostsDetail.vue"
                    );
                break;
            case "ExploitdbPocDetail":
                component =
                    import(
                        /*webpackChunkName:'ExploitdbPocDetail'*/
                        "@/views/cvepoc/ExploitdbPocDetail.vue"
                    );
                break;
            case "CliResultPopup":
                component =
                    import(
                        /*webpackChunkName:'CliResultPopup'*/
                        "@/views/control/CliResultPopup.vue"
                    );
                break;
            case "MoreTextPopup":
                component =
                    import(
                        /*webpackChunkName:'MoreTextPopup'*/
                        "@/views/control/MoreTextPopup.vue"
                    );
                break;
            case "MorePrePopup":
                component =
                    import(
                        /*webpackChunkName:'MorePrePopup'*/
                        "@/views/control/MorePrePopup.vue"
                    );
                break;
            case "WatchlistDetail":
                component =
                    import(
                        /*webpackChunkName:'WatchlistDetail'*/
                        "@/views/watchlist/WatchlistDetail.vue"
                    );
                break;
            case "ProfileFullResultPopup":
                component =
                    import(
                        /*webpackChunkName:'ProfileFullResultPopup'*/
                        "@/views/control/ProfileFullResultPopup.vue"
                    );
                break;
            case "ProxyHistoryPopup":
                component =
                    import(
                        /*webpackChunkName:'ProxyHistoryPopup'*/
                        "@/views/anonymous/ProxyHistoryPopup.vue"
                    );
                break;
            case "ProxyStatPopup":
                component =
                    import(
                        /*webpackChunkName:'ProxyStatPopup'*/
                        "@/views/anonymous/ProxyStatPopup.vue"
                    );
                break;
            case "WideProfileResult":
                component =
                    import(
                        /*webpackChunkName:'WideProfileResult'*/
                        "@/views/wide/WideProfileResult.vue"
                    );
                break;
            case "StatisticsPopup":
                component =
                    import(
                        /*webpackChunkName:'StatisticsPopup'*/
                        "@/views/dashboard/StatisticsPopup.vue"
                    );
                break;
            case "HtmlContentPopup":
                component =
                    import(
                        /*webpackChunkName:'HtmlContentPopup'*/
                        "@/views/control/HtmlContentPopup.vue"
                    );
                break;
            case "ScanAutoHistoryDailyPopup":
                component =
                    import(
                        /*webpackChunkName:'ScanAutoHistoryDailyPopup'*/
                        "@/views/dashboard/ScanAutoHistoryDailyPopup.vue"
                    );
                break;          
            case "DeepProfileResult":
                component =
                    import(
                        /*webpackChunkName:'DeepProfileResult'*/
                        "@/views/deep/DeepProfileResult.vue"
                    );
                break;                      
        }
        return component;
    }
}

export default new PopupUtil();